import '../../../../src/assets/stylus/ui/component/_jModalSlideForService.scss'

import { VDialog } from 'vuetify/components'

export default {
  name: 'j-modal-slide-for-service',
  components: {
    VDialog,
  },
  props: {
    modelValue: { type: Boolean, default: false },
  },
  render() {
    return (
      <div class="j_modal_slide_for_service">
        <v-dialog
          modelValue={this.modelValue}
          transition="slide-half-modal-transition"
          contentClass="slide_modal"
          width="unset"
          onUpdate:modelValue={(val) => this.$emit('update:modelValue', val)}
        >
          {this.$slots.default?.()}
        </v-dialog>
      </div>
    )
  },
}
